import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TextEditorWrapperService {
  public fullScreenEditorChange: Subject<number> = new Subject();

  constructor() {}
}
